import getCartItemVariant from '@jetshop/core/helpers/getCartItemVariant';
import Image from '@jetshop/ui/Image';
import { Price } from '../../Price';
import theme from '@jetshop/ui/utils/theme';
import React from 'react';
import styled, { css } from 'react-emotion';
import { Link } from 'react-router-dom';
import { ReactComponent as TrashSVG } from '../../../svg/trash.svg';
import { useFauxPricing } from './useFauxPricing';

const Wrapper = styled('div')`
  display: flex;
  background: white;
  margin-top: 1rem;

  > :first-child {
    flex: 1 1 60px;
    max-width: 60px;
    margin: 0 1rem 1rem 0;
  }
  > :last-child {
    flex: 1 1 70%;
    padding: 0.5rem;
  }
  .imageThumb {
    border: 2px solid #f3f3f3;
  }
`;

const ProductName = styled('div')`
  color: ${theme('colors.black')};
  font-family: ${theme('fontFamilies.body')};
  font-weight: normal;
  padding-right: 30px;
  width: 100%;
  white-space: nowrap;
  & > div {
    text-align: left;
  }
  h2 {
    font-size: 14px;
    line-height: 1.2;
    text-align: left;
    text-transform: none;
    margin: 0;
    width: calc(100% - 0.5rem);
  }
  span.subName {
    font-size: 14px;
    font-weight: 100;
  }
  .attribute {
    display: block;
    font-size: 14px;
  }
  a {
    color: ${theme('colors.black')};
    transition: all ease 0.3s;
    text-decoration: none;
    :hover {
      color: ${theme('colors.primary')};
    }
  }
`;

const ProductDetail = styled('section')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
`;

const ItemDetails = styled('div')`
  position: relative;
  display: flex;
  justify-content: space-between;
`;

export const LinePrice = styled(Price)`
  margin-top: 1rem;
  font-weight: 600;
  font-family: ${theme('fontFamilies.heavy')};
  text-align: right;
  .new-price {
    color: ${({ theme }) => theme.colors.red};
  }
  .old-price {
    color: ${({ theme }) => theme.colors.mediumgrey};
    text-decoration: line-through;
  }
`;

const RemoveItem = styled('div')`
  text-align: right;
  position: absolute;
  top: 0;
  right: 0;
  button {
    padding: 0;
    border-radius: 50%;
    outline: none;
    border: none;
    background: transparent;
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  svg {
    height: 1.25em;
    width: 1.25em;
  }
`;

const ListItem = ({
  item,
  className = '',
  packageHandler,
  removable = true,
}) => {
  const { variantImage, hasVariantImage } = getCartItemVariant(item);
  const { fauxPrice } = useFauxPricing(item);
  const checker = (text) => {
    if (text.toLowerCase().indexOf('storlek') > -1) {
      text = 'Storlek';
    } else if (text.toLowerCase().indexOf('längd') > -1) {
      text = 'Längd';
    }
    return text;
  };

  return (
    <Wrapper className={className}>
      {/* <div>
        {item?.images.length > 0 && (
          <Image
            className="imageThumb"
            aspect="4:6"
            sizes="5rem"
            src={hasVariantImage ? variantImage.url : item.images[0].url}
            alt={hasVariantImage ? variantImage.alt : item.images[0].alt}
            quality={80}
          />
        )}
      </div> */}
      <ProductDetail>
        <ItemDetails>
          <ProductName>
            <Link to={item.primaryRoute.path}>
              <h2 data-testid="item-name">{item.name}</h2>
              {item.variant && (
                <span className="subName">
                  {checker(item.variants.options[0].name)}: {item.variant}
                </span>
              )}
            </Link>
            <LinePrice
              data-testid="item-price"
              price={fauxPrice}
              previousPrice={item.previousPrice}
            />
          </ProductName>

          {removable && (
            <RemoveItem>
              <button onClick={() => packageHandler(item, false)}>
                <TrashSVG />
              </button>
            </RemoveItem>
          )}
        </ItemDetails>
      </ProductDetail>
    </Wrapper>
  );
};

export default ListItem;
